require('./bootstrap');

const lang          = window.Laravel.lang;
const has_gtag      = (typeof window.qweekle.gtag !== "undefined") ? window.qweekle.gtag : false;

const ease          = require('jquery.easing');
const arrive        = require('arrive');
const jqsignature   = require('jq-signature');
const inputmask     = require('jquery.inputmask/dist/jquery.inputmask.bundle.js');
const dropdown      = require('./lib/jquery.dropdown.js');
const selectize     = require('selectize');
const datepicker    = require('bootstrap-datepicker');
const serializer    = require('form-serializer');
const swipe         = require('jquery-touchswipe');
const moment        = require("moment");

var ResponsiveBootstrapToolkit = require('responsive-toolkit');
var hammerjs        = require("hammerjs");
var swal            = require('sweetalert2');
const { create }    = require('domain');

//var fullcalendar = require('fullcalendar');
//var fullcalendarFr = require('fullcalendar/dist/locale/fr.js');

if (lang != 'en')
    require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.' + lang + '.min.js');

//let setHeight = true;

/*const log = require('loglevel');
//log.enableAll();*/


(function ($, viewport) {

    if (!navigator.cookieEnabled)
        $('#cookiesAlert').show();

    function qLog(data, color) {
        console.log('%c' + data, "color:" + color);
    }

    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    function showIEAlert() {
        $('#ieAlert').show();
    }

    if (isIE()) {
        showIEAlert();
        return false;
        return false;
    }

    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            if (ns.includes("noPreventDefault")) {
                this.addEventListener("touchstart", handle, {passive: false});
            } else {
                this.addEventListener("touchstart", handle, {passive: true});
            }
        }
    };

    $('[data-toggle="popover"]').popover({html: true});
    $('[data-toggle="tooltip"]').tooltip();

    /******* Date picker --- */
    $.fn.startDatePicker = function () {

        var field = this,
            min_start_at = $(field).data('min_start_at');

        $(field)
            .datepicker({
                orientation: "bottom",
                autoclose: true,
                format: "dd/mm/yyyy",
                language: lang,
                startDate: min_start_at,
            })
            .attr('readonly', 'readonly');
    };

    if ($('input[name="start_at"]').length > 0)
        $('input[name="start_at"]').startDatePicker();

    // other date picker
    $('.datepicker').datepicker({
        orientation: "top",
        autoclose: true,
        format: "dd/mm/yyyy",
        language: lang,
        startView: 2,
    });

    $('.birthday').inputmask({alias: "date", inputFormat: "dd/mm/yyyy"});

    /**Member ticketing Datepicker */
    $('.ticket-dp-range').datepicker({
        orientation: "bottom",
        autoclose: true,
        format: "dd/mm/yyyy",
        language: lang,
        //startView: 2,
    });
    /******* Date picker --- */

    $.fn.Calendar = function () {

        if ($(this).length == 0)
            return false;

        var $url = $(this).data('url'),
            loader = this,
            start_at = $('[name="start_at"]').val(),
            end_at = $('[name="end_at"]').val()
        ;

        $.ajax({
            url: $url,
            data: {
                start_at: start_at,
                end_at: end_at
            },
            success: function (r) {
                $(loader).html(r);

                $(loader).find('a.day').on('click', function (e) {
                    var url = $(this).data('url');
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        success: function (r) {
                            if (r.refresh == true)
                                document.location.reload();

                        }
                    })
                });

            }
        });

    };
    $('#calendar').Calendar();

    $.fn.qtyMinusPlus = function () {

        let fieldGroup = $(this),
            fieldInput = fieldGroup.find('input[type="number"]'),

            plusBtn = fieldGroup.find('button[data-type="plus"]'),
            minusBtn = fieldGroup.find('button[data-type="minus"]'),

            min = parseInt(fieldInput.attr('min')),
            max = parseInt(fieldInput.attr('max')),

            minQty = parseInt(fieldInput.data('min_qty')),
            maxQty = parseInt(fieldInput.data('max_qty'))
        ;

        /*console.log("qtyMinusPlus", {
            //min: min,
            //max: max,

            minQty: minQty,
            maxQty: maxQty,

            TminQty: isNaN(minQty),
            TmaxQty: isNaN(maxQty),
        });*/

        let updateField = function (mod) {

            var qty = parseInt(fieldInput.val()),
                qty = qty + mod;

            //console.log("mod", mod);
            //console.log("qty", qty);

            plusBtn.prop('disabled', false);
            minusBtn.prop('disabled', false);

            if (qty < min) {
                console.warn(" < min ", min);
                qty = min;
            }

            if (qty > max) {
                console.warn(" > max ", max);
                qty = max;
            }

            if (qty <= min)
                minusBtn.prop('disabled', true);

            if (qty >= max)
                plusBtn.prop('disabled', true);


            if (!isNaN(minQty)) {
                if (qty < minQty)
                    qty = (mod < 1) ? 0 : minQty
            }

            if (!isNaN(maxQty)) {
                if (qty > maxQty)
                    qty = maxQty
            }


            fieldInput.val(qty);
            fieldInput.trigger('change');

            fieldInput.on('cut copy paste', function (e) {
                e.preventDefault();
            });


        }

        plusBtn
            .off('click')
            .on('click', function () {
                updateField(+1);
            });

        minusBtn
            .off('click')
            .on('click', function () {
                updateField(-1);
            });

        fieldInput
            .on('change textInput input', function () {

                var value = parseInt($(this).val()),
                    min = parseInt($(this).attr("min")),
                    max = parseInt($(this).attr("max"));

                if (value < min) $(this).val(min);
                if (value > max) $(this).val(max);

                if (!isNaN(minQty)) {
                    if (value < minQty)
                        $(this).val((value < 1) ? 0 : minQty)
                }

                //
                if (!isNaN(maxQty)) {
                    if (value > maxQty)
                        $(this).val(maxQty)
                }

            });

    };

    $.fn.qtyField = function () {

        $.each($('.qtyMinusPlus'), function () {
            $(this).qtyMinusPlus();
        });

    };
    $.fn.qtyField();

    $.fn.pricing = function () {

        if (this.length == 0)
            return false;

        var loader = this,
            url = $(loader).data('url');

        qLog("[ CALL ] pricing", "lightgoldenrodyellow");

        $.fn._updatePrice = function (url) {

            qLog("[ CALL ] _updatePrice", "lightgoldenrodyellow");

            var data = $('#pricing-form').serializeObject();

            $.each($('input.option_checkbox:checked'), function () {

                var _compound_id = "_" + $(this).data('compound_id'),
                    _product_id = $(this).data('compound_product_id'),
                    _i = $(this).data('i'),
                    _item_id = $(this).data('compound_item_id'),
                    _qty = $('[name="order_item_datas[' + _i + '][compounds][' + _compound_id + '][qty]"]').val(),
                    _data_product = {};

                _data_product[_product_id] = {
                    'product_id': _product_id,
                    'qty': _qty,
                    item_id: _item_id
                };

                if (typeof data['order_item_datas'][_i]['compounds'][_compound_id] !== "undefined") {
                    data['order_item_datas'][_i]['compounds'][_compound_id]['products'] = _data_product;
                }

            });

            $.ajax({
                url: url,
                type: "POST",
                dataType: 'json',
                data: data,
                success: function (r) {
                    $('.total_price').text(r.total);
                }
            });


        };
        this._updatePrice(url);

        $(loader).find('input')
            .on('change', function () {

                qLog("[ CHANGE ] " + $(this).attr('name') + " to " + $(this).val(), "greenyellow");

                // update compound qty related to product qty
                if ($(this).attr('name') == 'qty') {
                    $('.compound_qty_choice').val($(this).val());
                    $('.option_rel_qty').text('x' + $(this).val());
                }

                if ($(this).data('has_rel') === "main_qty") {

                    qLog("[ CHANGE ] main Qty", "orangered");

                    //console.log("Item relative to main", $('[data-rel="main_qty"]').length);

                    $('[data-rel="main_qty"]').val($(this).val());
                    $('[data-rel="main_qty_text"]').text('x' + $(this).val());
                    //$('.compound_qty_choice').val( $(this).val() );
                    //$('.option_rel_qty').text('x'+ $(this).val() );
                }

                $(loader)._updatePrice(url);
            });

        $(loader).find('.add-to-cart')
            .on('click', function () {

                var url = $('#pricing-form').attr('action'),
                    data = $('#pricing-form').serializeObject();

                $.each($('input.option_checkbox:checked'), function () {

                    var _compound_id = "_" + $(this).data('compound_id'),
                        _product_id = $(this).data('compound_product_id'),
                        _item_id = $(this).data('compound_item_id'),
                        _i = $(this).data('i'),
                        _qty = $('[name="order_item_datas[' + _i + '][compounds][' + _compound_id + '][qty]"]').val(),
                        _data_product = {};

                    _data_product[_product_id] = {
                        'product_id': _product_id,
                        'qty': _qty,
                        item_id: _item_id
                    };

                    // TODO + FIXme : qty should always be in [products][{product_id}][qty]
                    if (typeof data['order_item_datas'][_i]['compounds'][_compound_id] !== "undefined") {
                        data['order_item_datas'][_i]['compounds'][_compound_id]['products'] = _data_product;
                    }

                });

                $.ajax({
                    url: url,
                    dataType: 'json',
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $('#app-loading').fadeIn('fast');
                    },
                    error: function (xhr, status, error) {
                        $('#app-loading').fadeOut('fast');
                        $.each(xhr.responseJSON.errors, function (field, msg) {
                            var f = field.split('.');
                            $('[name="further[' + f[1] + ']"]').parent('div').find('span.text-danger').remove();
                            $('[name="further[' + f[1] + ']"]').parent('div').addClass('has-error');
                            $('[name="further[' + f[1] + ']"]').after('<span class="text-danger">' + msg + '</span>');
                        });
                    },
                    success: function (r) {

                        $('#app-loading').fadeOut('fast');

                        if (r.success == true) {

                            $('.head-cart-counter').headCartCounter(r.nbr_items);
                            // success modal
                            $('#modal').load(r.success_url, function () {
                                $(this).modal({backdrop: 'static', keyboard: false, show: true});
                            });

                            // Google tag
                            if ((has_gtag == true) && (typeof r.gtag !== "undefined")) {
                                if (!Array.isArray(r.gtag)) {
                                    r.gtag = [r.gtag];
                                }
                                window?.dataLayer?.push({ 'event': 'add_to_cart', 'ecommerce': { "affiliation": r.affiliation, "items": r.gtag } });
                            }


                        } else {
                            //alert(r.msg);
                            $.fn.swal({
                                title: 'Oops',
                                text: r.msg,
                                type: 'warning',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false
                            });

                            // iframe Height
                            //$("#app").iframeHeight('cartError');
                        }

                        // iframe Height
                        //$("#app").iframeHeight('addToCart');
                    }
                });

            });

        // highlight options
        $(loader).find('.option_checkbox').on('change', function () {

            var optRel = $(this).data('opt');

            $('#selectQty_' + optRel).hide();
            $('#opt_' + optRel).find('.radio.selected').removeClass('selected');

            if ($(this).prop('checked') == true) {

                var rel = $(this).data('rel');
                $('.radio[data-rel="' + rel + '"]').addClass('selected');

                // filling text (right of title)
                var txt = $('.radio[data-rel="' + rel + '"]').find('.radio-opt').text();
                $('#selectText_' + optRel).text(txt);

                // Show or hide Qty choice
                if ($('#qty_choice_' + optRel).length > 0) {
                    if ($(this).val() == '0') {
                        $('#qty_choice_' + optRel).hide();
                        //console.log("hide qty_choice", optRel, $(this).val());
                    } else {
                        $('#qty_choice_' + optRel).show();
                        //console.log("show qty_choice", optRel, $(this).val());
                    }
                }

                if ($(this).val() != '0') {
                    $('#selectQty_' + optRel).show();
                }

                $('#qty_choice_' + optRel).find('input[type="number"]')
                    .on('change', function () {
                        var _qty = $(this).val();
                        $('#selectQty_' + optRel).text('x' + _qty);
                    });

            }

        });

        //popover
        $('[data-toggle="popover"]').popover({
            html: true,
            placement: 'middle'
        });

        // checking default (first load)
        $.each($('.options-list'), function () {

            if ($(this).find('input:checked').length <= 0)
                $(this).find('input[type="radio"]:first').prop('checked', true);

        });

        // commented on 18.03.21 - abusive XHR ?
        $(loader).find('input[type="radio"]:checked').trigger('change');

    };
    $('#options-loader').pricing();

    $.fn.cart = function () {

        if (this.length == 0)
            return false;

        var loader = this;

        $(loader).find('.rmFromCart')
            .on('click', function () {

                var msg = $(this).data('msg'),
                    ok = $(this).data('btn_ok'),
                    nok = $(this).data('btn_nok'),
                    url = $(this).data('url');

                $.fn.swal({
                    title: '',
                    text: msg,
                    type: 'warning',
                    showCancelButton: true,
                    //confirmButtonColor: '#f44336',
                    //cancelButtonColor: '#333',
                    confirmButtonText: ok,
                    cancelButtonText: nok,

                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    cancelButtonClass: 'btn btn-default',

                    allowOutsideClick: false
                }).then(function () {
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        type: 'POST',
                        data: {
                            _token: window.Laravel.csrfToken,
                        },
                        success: function (r) {
                            if (r.success == true) {

                                // Google tag
                                if ((has_gtag == true) && (typeof r.gtag !== "undefined")) {
                                    window?.dataLayer?.push({ 'event': 'remove_from_cart', 'ecommerce': { 'affiliation': r.affiliation, 'items': [ r.gtag ] } });
                                }

                                document.location.reload();
                            }else{
                                $.fn.swal({
                                    title: '',
                                    text: r.msg,
                                    type: 'warning',
                                    //showCancelButton: true,
                                    //confirmButtonColor: '#f44336',
                                    //cancelButtonColor: '#333',
                                    confirmButtonText: ok,
                                    //cancelButtonText: nok,
                
                                    buttonsStyling: false,
                                    confirmButtonClass: 'btn btn-danger',
                                    //cancelButtonClass: 'btn btn-default',
                
                                    //allowOutsideClick: false
                                })
                            }
                        }
                    });
                });

            });

        $(loader).find('[data-remove_giftcard]')
            .on("click", function () {
                let removeGiftCardUrl = $(this).data('remove_giftcard');
                document.location.href = removeGiftCardUrl;
            });

    };
    $('#cart-loader').cart();

    $.fn.headCartCounter = function (count) {
        $('.head-cart-counter').text(count);
        if (count > 0) {
            $('.head-cart-counter').show();
        } else {
            $('.head-cart-counter').hide();
        }
    };

    $.fn.iCard = function () {
        var iCardForm = this,
            iCardImg = $('#icard-img');

        $('[name="icard_id"]')
            .off('change')
            .on('change', function () {
                $(iCardForm).trigger('submit');
            });

        //setHeight = false;

        /*if(iCardImg.prop('complete')){
            $('#app').iframeHeight('icard');
        }else{
            iCardImg.on('load',function(){
                $('#app').iframeHeight('icard');
            });
        }*/

    };

    if ($('#icard-form').length > 0)
        $('#icard-form').iCard();

    $.fn.swal = function (arg) {
        return swal(arg);
    };

    $.fn.reload_activitiesTable = function (options) {

        var loader = this,
            url = (options.url) ? options.url : $(this).data('url'),
            qty = $('[name="qty"]').val(),
            start_at = $('[name="start_at"]').val();

        $.ajax({
            url: url,
            data: {
                qty: qty,
                start_at: start_at,
            },
            beforeSend: function () {
                $('.activities-wait').show();
            },
            success: function (r) {
                $(loader).html(r);

                $('[data-toggle="popover"]')
                    .popover({
                        html: true,
                        container: 'body',
                        placement: function (context, source) {
                            var position = $(source).position();

                            if (position.left > 515) {
                                return "left";
                            }

                            if (position.left < 515) {
                                return "right";
                            }

                            if (position.top < 110) {
                                return "bottom";
                            }

                            return "top";
                        }
                    });

                $('ul.pagination > li > a')
                    .off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        var url = $(this).attr("href");
                        $('#activities-table_loader').activitiesTable({url: url});
                    })
                ;

                $('[data-update_date]')
                    .off("click")
                    .on('click', function () {
                        var date = $(this).data('update_date');
                        $('[name="start_at"]').val(date).trigger("change");
                    });

                $('.activities-wait').hide();

                //$('#app').iframeHeight('slots');
            }
        });
    };

    $.fn.activitiesTable = function (options) {

        if (this.length == 0)
            return false;

        $('[name="qty"]')
            //.off('change textInput input')
            .on('change textInput input', function () {

                var timer;

                clearTimeout(timer);

                timer = setTimeout(function () {
                    console.info("ouwhou");
                    $('#activities-table_loader').reload_activitiesTable(options);
                }, 600);

            });

        $('[name="start_at"]')
            .off("change")
            .on('change', function () {
                $('#activities-table_loader').reload_activitiesTable(options);
            })

        $('#activities-table_loader').reload_activitiesTable(options);

    };

    $.fn.multiActions = function (loader, options) {

        var qtyTimer = null;

        $('[data-toggle="popover"]')
            .popover({
                html: true,
                container: 'body',
                placement: function (context, source) {
                    var position = $(source).position();

                    if (position.left > 515) {
                        return "left";
                    }

                    if (position.left < 515) {
                        return "right";
                    }

                    if (position.top < 110) {
                        return "bottom";
                    }

                    return "top";
                }
            });

        $('[name="start_at"]')
            .off('change')
            .on('change', function () {
                $(loader).multiActivity(options);
            });

        $('[name^="activities_qty"]')
            .off('change textInput input')
            .on('change textInput input', function () {

                var value = parseInt($(this).val()),
                    min = parseInt($(this).attr("min")),
                    max = parseInt($(this).attr("max"));

                if (value < min)
                    $(this).val(min);

                if (value > max)
                    $(this).val(max);

                clearTimeout(qtyTimer);

                qtyTimer = setTimeout(function () {
                    $(loader).multiActivity(options);
                }, 450);

            });

        $('[data-update_date]')
            .off("click")
            .on('click', function () {
                var date = $(this).data('update_date');
                $('[name="start_at"]').val(date).trigger("change");
            });

        $('.activities-wait').hide();

        //$('#app').iframeHeight('slots');

        $("a[data-slot_url]")
            .off('click')
            .on('click', function (e) {

                e.preventDefault();
                var url = $(this).data('slot_url');

                if ($(this).attr("disabled") != "disabled") {
                    $('#multiActivity_form').attr('action', url);
                    $('#multiActivity_form').trigger('submit');
                } else {
                    /**/
                }


            });
    };

    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    $.fn.multiPack = function (options) {

        // Listen for any qty fields change
        // Sum all qty fields into qty_total
        // If qty_total >= 1 load slots for each steps
        // Listen for click on slot
        // If selected slot changes reload other steps' slots
        // Listen for any date change
        // reload concerned step slots

        /*$('[data-slots_loader]').each(function () {
            $(this).html('<div class=\'multi_activity-alert text-center text-warning\'><i class=\'mdi mdi-alert\'></i> ' + options.noActivitySelectedText + '</div>');
        });*/
        
        let qty_total = 0,
            loader = $(this);

        $('input.activities_updater')
            .off('change')
            .on('change', function () {
                $('input[name^="packs_qty"]').first().trigger('change');

                if ($(this).attr("name") === "start_at") {

                    let setDate = moment($(this).val(), 'DD/MM/YYYY')

                    $('[data-previous-at_for]').val(setDate.format("DD/MM/YYYY"));                    
                    $('[data-is_previous_at_of]').text(setDate.format('DD/MM/YYYY'))

                }

            });

        $('input[name^="packs_qty"]')
            .off('change')
            .on('change', function () {

                qty_total = 0;

                $('input[name^="packs_qty"]').each(function () {
                    qty_total += Number($(this).val());
                });

                if (qty_total >= 1) {

                    var packs_qty = $("#multiPack_form").serializeFormJSON();

                    $('.pack-stepper').show();

                    $('div.pack-activity-choice').each(function (item) {
                        // serialize packs_qty inputs array
                        let choice_loader = $(this),
                            choice_id = choice_loader.data('choice_id'),
                            slots_loader = $('div[data-slots_loader="' + choice_id + '"]'),
                            slots_url = slots_loader.data('pack_slots_url'),
                            n = choice_loader.data('i'),
                            start_at = $('input.activities_updater').val();

                        $.ajax({
                            url: slots_url,
                            method: "POST",
                            data: {
                                _token: $('meta[name="csrf-token"]').attr('content'),
                                qty_total: qty_total,
                                start_at: start_at,
                                choice_id: choice_id,
                                n: n,
                                ...packs_qty
                            },
                            beforeSend: function () {
                                slots_loader.css('opacity', '.5')
                                $('[data-locations_loader="' + choice_id + '"]').html('&nbsp;');
                            },
                            success: function (response) {

                                slots_loader.html(response);
                                $.fn.multiPackSteps(options, n);

                                let foundedSlots = slots_loader.find('[data-pack_selected_slot]').length;

                                if (foundedSlots <= 0) {
                                    //loader.find('.pack-activity').hide();
                                    loader.find('.pack-slot').html('<strong class="text-danger"><i class="mdi mdi-badminton"></i> ' + options.noSlotsFoundText + '</strong>');
                                    return;
                                }

                                let location_auto = slots_loader.find('[data-pack_selected_slot]').first().data('location_auto');

                                // mode constrain if only one slot
                                if ((foundedSlots == 1)
                                    && (n !== 0)
                                    && (options.pack_is_constrained === "1")) {

                                    loader.find('.panel-body').hide();
                                    slots_loader.multiPackSlotsSlider(options, choice_id, location_auto, n);
                                    slots_loader.find('[data-pack_selected_slot]').first().trigger('click');

                                } else {
                                    loader.find('.panel-body').show();
                                    slots_loader.show();
                                    slots_loader.multiPackSlotsSlider(options, choice_id, location_auto, n);
                                }
                                slots_loader.css('opacity', '1')
                            }
                        });
                    });
                } else {

                    $('.pack-stepper').hide();

                    //reset slots loaders
                    $('[data-slots_loader]').each(function () {
                        //$(this).html('<div class=\'multi_activity-alert text-center text-warning\'><i class=\'mdi mdi-alert\'></i> ' + options.noActivitySelectedText + '</div>');
                    });

                    $.fn.multiPackSteps(options, 0);
                }
            });

        $(document)
            .off('click', '[data-previous_at]')
            .on('click', '[data-previous_at]', function () {

                let qty_total = 0;
                let start_at = $('[name="start_at"]').val();

                $('input[name^="packs_qty"]').each(function () {
                    qty_total += Number($(this).val());
                });

                let clickedChoiceId = $(this).data('pack_choice_id');                
                let clickedChoiceRank = $('[data-choice_id="' + clickedChoiceId + '"]').data('i');
                // let previousChoiceRank = ((clickedChoiceRank - 1) > 0) ? (clickedChoiceRank - 1) : 0;  
                // let previousChoiceId = $('[data-i="' + previousChoiceRank + '"]').data('choice_id');

                let previousAtString    = (clickedChoiceRank == 0) ? start_at : $('[name="pack_choices[' + clickedChoiceId + '][previous_at]"]').val();                
                let previousAt          = moment(previousAtString, "DD/MM/YYYY");
                let _packChoiceId       = $(this).data('pack_choice_id');
                
                if ($(this).data('previous_at') === '+1') {
                    previousAt.add(1, 'days')
                } else {
                    previousAt.subtract(1, 'days')
                }

                // $('[name="previous_at"][data-pack_choice_id="' + _packChoiceId + '"]').val(previousAt.format("YYYY-MM-DD"))
                // $('[data-is_previous_at_of="' + _packChoiceId + '"]').text(previousAt.format('DD/MM/YYYY'))

                let newPreviousAt = previousAt.format("DD/MM/YYYY");
                $('[name="pack_choices[' + _packChoiceId + '][previous_at]"][data-pack_choice_id="' + _packChoiceId + '"]').val(newPreviousAt)
                $('[data-is_previous_at_of="' + _packChoiceId + '"]').text(newPreviousAt);

                /*console.log("🔥", {
                    start_at: start_at,
                    takeStartAt: (clickedChoiceRank == 0),
                    clickedChoiceId: clickedChoiceId,
                    clickedChoiceRank: clickedChoiceRank,
                    previousAtString: previousAtString,
                    previousAt: previousAt,
                    _packChoiceId: _packChoiceId,
                    newPreviousAt: newPreviousAt,
                });*/

                /*
                    console.log($(this).data('previous_at'), {
                        previousAtString: previousAtString,
                        previousAt: previousAt,
                        _FR: previousAt.format('DD/MM/YYYY'),
                        _L: previousAt.format('L'),
                        _packChoiceId: _packChoiceId,
                    })
                */

                let packs_qty = $("#multiPack_form").serializeFormJSON();

                delete packs_qty.start_at;

                // should only refetch the clicked step's slots
                let choice_loader = $('div.pack-activity-choice[data-choice_id="' + _packChoiceId + '"]'),
                    choice_id = choice_loader.data('choice_id'),
                    slots_loader = $('div[data-slots_loader="' + choice_id + '"]'),
                    slots_url = slots_loader.data('pack_slots_url'),
                    n = choice_loader.data('i');
                $.ajax({
                    url: slots_url,
                    method: "POST",
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        qty_total: qty_total,
                        start_at: previousAt.format('DD/MM/YYYY'),
                        choice_id: choice_id,
                        n: n,
                        ...packs_qty
                    },
                    beforeSend: function () {
                        slots_loader.css('opacity', '.5')
                        $('[data-locations_loader="' + choice_id + '"]').html('&nbsp;');
                    },
                    success: function (response) {

                        slots_loader.html(response);
                        $.fn.multiPackSteps(options, n);

                        let foundedSlots = slots_loader.find('[data-pack_selected_slot]').length;

                        if (foundedSlots <= 0) {
                            //loader.find('.pack-activity').hide();
                            loader.find('.pack-slot').html('<strong class="text-danger"><i class="mdi mdi-badminton"></i> ' + options.noSlotsFoundText + '</strong>');
                            return;
                        }

                        let location_auto = slots_loader.find('[data-pack_selected_slot]').first().data('location_auto');

                        // mode constrain if only one slot
                        if ((foundedSlots == 1)
                            && (n !== 0)
                            && (options.pack_is_constrained === "1")) {

                            loader.find('.panel-body').hide();
                            slots_loader.multiPackSlotsSlider(options, choice_id, location_auto, n);
                            slots_loader.find('[data-pack_selected_slot]').first().trigger('click');

                        } else {
                            loader.find('.panel-body').show();
                            slots_loader.show();
                            slots_loader.multiPackSlotsSlider(options, choice_id, location_auto, n);
                        }
                        slots_loader.css('opacity', '1')
                    }
                });

            })
        ;

        // onload call change on first qty input
        $('input[name^="packs_qty"]').first().trigger('change');

    };

    $.fn.multiPackSlotsSlider = function (options, choice_id, location_auto, n) {
        qLog("[ CALL ] multiPackSlotsSlider  ->" + choice_id, 'orange');

        let choice = $(this),
            slide = choice.find('.pack-slot-slide'),
            container = slide.find('.pack-slot-slider-container'),
            slider = container.find('.btn-group-slider'),
            btn_qty = slider.find('.btn').length,
            sliding_left = (slider.outerWidth() / btn_qty),
            slide_position = 0,
            slide_visible = Math.floor(container.outerWidth() / sliding_left),
            slide_qty = slide_visible,
            left = 0,
            toSlide = (ResponsiveBootstrapToolkit.current() === "xs") ? 1 : 2;

        slide
            .off('click', '[data-pack_shift]')
            .on('click', '[data-pack_shift]', function () {

                let direction = $(this).data('pack_shift');

                slide_position = (direction == 'left') ? slide_position - toSlide : slide_position + toSlide;

                // max at left
                if (slide_position <= 0) slide_position = 0;

                // max at right
                if (slide_position >= (btn_qty - slide_visible)) slide_position = (btn_qty - slide_visible);

                left = -(slide_position * sliding_left);

                slider.animate({left: left}, 300, "easeOutQuint");

            })

            .off('click', '[data-pack_selected_slot]')
            .on('click', '[data-pack_selected_slot]', function () {

                $('input[name="step_agendas[' + n + ']"]').val('');

                let qty_total = 0;
                $('input[name^="packs_qty"]').each(function () {
                    qty_total += Number($(this).val());
                });

                let selected_slot = $(this).data('pack_selected_slot'),
                    pack_location_url = $(this).data('multi_pack_location_url'),
                    location_loader = $('[data-locations_loader="' + choice_id + '"]'),
                    start_at = $('[name="start_at"]').val(),
                    previous_option_id = 0;

                slider.find('[data-pack_selected_slot]').removeClass('active');
                $(this).addClass('active');

                //$.fn.resetPackAfter(options, choice_id, n);

                // Set slot
                let pack_recap = $('[data-pack_recap="' + choice_id + '"]'),
                    slot_value = $(this).find('span.start_at').html(),
                    separator = pack_recap.data('separator');

                pack_recap.find('span.pack-check').html('<i class="mdi mdi-check text-success"></i>');

                if ((options.pack_is_constrained === "1") && (options.constrained_show_slot !== "0")) {
                    pack_recap.find('span.pack-slot').html(separator + " " + slot_value);
                } else {
                    pack_recap.find('span.pack-slot').hide();
                }

                var packs_qty = $("#multiPack_form").serializeFormJSON();
                var selected_slot_agenda_id = $(this).data('agenda_id');
                $('input[name="step_agendas[' + n + ']"]').val(selected_slot_agenda_id);

                // GET LOCATIONS
                $.ajax({
                    url: pack_location_url,
                    data: {
                        qty_total: qty_total,
                        start_at: start_at,
                        choice_id: choice_id,
                        location_auto: location_auto,
                        n: n,
                        ...packs_qty,
                    },
                    beforeSend: function () {

                        location_loader.hide();
                        location_loader.html('&nbsp;');

                        $('#pack-submitter').prop('disabled', true);

                    },
                    success: function (response) {

                        location_loader.html(response);

                        // Selection auto du lieu
                        if (location_auto <= 0) {

                            setTimeout(function () {
                                location_loader.show();

                                let selector = location_loader.find('.pack-locations-selector');

                                /*$("html, body").animate({
                                    scrollTop: location_loader.offset().top
                                }, 500);*/

                                location_loader
                                    .off('click', '[data-select_agenda_activity]')
                                    .on('click', '[data-select_agenda_activity]', function () {

                                        $(this).parent('div').find('a.active').removeClass('active');
                                        $(this).addClass("active");

                                        $('[name="pack_choices[' + choice_id + '][agenda_activity_id]"]').val($(this).data('select_agenda_activity'));
                                        $.fn.multiPackSteps(options, n);

                                        // Locations label
                                        let active_location = selector.find('.pack-location.active');
                                        if (active_location.length > 0) {
                                            let location_label = active_location.find('.pack-location-text').text();
                                            pack_recap.find('span.pack-location').html(" - " + location_label);
                                        }

                                    });

                                // auto select uniq location
                                if (location_loader.find('[data-select_agenda_activity]').length == 1) {
                                    location_loader.find('[data-select_agenda_activity]:first()').trigger('click');
                                } else {
                                    // Si plusieurs choix de location possible on affiche le panel body
                                    if (location_loader.find('[data-select_agenda_activity]').length > 0) {
                                        choice.parent().show();
                                    }
                                }

                            }, 200);

                            // Choix du lieu
                        } else {
                            $.fn.multiPackSteps(options, n);
                        }

                    }
                });

            })
        ;

        slider.swipe({
            //Generic swipe handler for all directions
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {

                if (direction == "left")
                    slide.find('[data-pack_shift="right"]').trigger("click");


                if (direction == "right")
                    slide.find('[data-pack_shift="left"]').trigger("click");

            }
        });

    };

    $.fn.multiActivity = function (options) {

        if (this.length == 0)
            return false;

        var loader = this,
            url = options.url,
            zero_qty = $(loader).data('zero_qty'),
            qty = 0;

        $.each($('[name^="activities_qty"]'), function () {
            qty = qty + parseInt($(this).val());
        });

        if (qty > 0) {
            $.ajax({
                url: url,
                data: $('#multiActivity_form').serialize(),
                beforeSend: function () {
                    $('.activities-wait').show();
                },
                success: function (r) {

                    $(loader).html(r);

                    $.fn.multiActions(loader, options);
                }
            });
        } else {
            $(loader).html(zero_qty);
            $.fn.multiActions(loader, options);
        }
    };

    $.fn.ticketing = function (options) {

        var pricing_url = options.pricing_url,
            addToCard_url = options.addToCard_url,
            timer = null;

        $(document)

            .off('change textInput input', '.ticket_qty')
            .on('change textInput input', '.ticket_qty', function () {

                clearTimeout(timer);

                timer = setTimeout(function () {
                    $.ajax({
                        url: pricing_url,
                        type: "POST",
                        data: $('#ticketingForm').serialize(),
                        dataType: "json",
                        beforeSend: function () {
                            $('.add-to-cart').prop('disabled', true);
                        },
                        success: function (r) {

                            $('.total_price').text(r.total);

                            if (r.qty_total > 0) {
                                $('.add-to-cart').prop('disabled', false);
                            }
                        }
                    });
                }, 300);

            })

            .off('click', '.add-to-cart')
            .on('click', '.add-to-cart', function () {
                $.ajax({
                    url: addToCard_url,
                    dataType: 'json',
                    data: $('#ticketingForm').serialize(),
                    type: 'POST',
                    beforeSend: function () {
                        $('#app-loading').fadeIn('fast');
                    },
                    error: function (xhr, status, error) {
                        $('#app-loading').fadeOut('fast');
                        $.each(xhr.responseJSON.errors, function (field, msg) {
                            var f = field.split('.');

                            $('[name="further[' + f[1] + ']"]').parent('div').find('span.text-danger').remove();
                            $('[name="further[' + f[1] + ']"]').parent('div').addClass('has-error');
                            $('[name="further[' + f[1] + ']"]').after('<span class="text-danger">' + msg + '</span>');
                        });
                    },
                    success: function (r) {

                        $('#app-loading').fadeOut('fast');

                        if (r.success == true) {

                            $('.head-cart-counter').headCartCounter(r.nbr_items);
                            // success modal
                            $('#modal').load(r.success_url, function () {
                                $(this).modal({backdrop: 'static', keyboard: false, show: true});
                            });

                            // Google tag 
                            if ((has_gtag == true) && (typeof r.gtag !== "undefined")) {
                                if (!Array.isArray(r.gtag)) {
                                    r.gtag = [r.gtag];
                                }
                                window?.dataLayer?.push({ 'event': 'add_to_cart', 'ecommerce': { 'affiliation': r.affiliation, 'items': r.gtag } });
                            }

                        } else {
                            //alert(r.msg);
                            $.fn.swal({
                                title: 'Oops',
                                text: r.msg,
                                type: 'warning',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false
                            });
                        }

                        // iframe Height
                        //$("#app").iframeHeight('addToCart');
                    }
                });
            })
        ;

    };

    $.fn.subaccount = function (options) {

        var sub_loader = this,
            sub_url = $(this).data('url');

        $.ajax({
            url: sub_url,
            success: function (r) {

                if (r.length <= 0)
                    return false;

                $(sub_loader).html(r);
                $(sub_loader).parent('tr').show();
                $('.birthday').inputmask({alias: "date", inputFormat: "dd/jj/aaaa"});

                // ADD SUB
                $(sub_loader).find('[name^="new_subaccount"]')
                    .off('change')
                    .on('change', function () {

                        var sub_add_url = $(this).data('sub_add_url'),
                            sub_datas = $(sub_loader).find('input[name^="subaccounts"], select[name^="subaccounts"]').serializeObject(),
                            token = $('meta[name="csrf-token"]').attr('content'),
                            existing_sub_id = $(sub_loader).find('[name^="new_subaccount"]').val();

                        $.ajax({
                            url: sub_add_url,
                            data: {
                                _token: token,
                                data: sub_datas,
                                existing_sub_id: existing_sub_id,
                            },
                            //dataType: 'json',
                            type: 'PUT',
                            success: function (r) {
                                $(sub_loader).subaccount();
                            }
                        });

                    });

                // ADD SUB
                $(sub_loader).find('.btn-add-sub')
                    .off('click')
                    .on('click', function () {
                        var sub_add_url = $(this).data('sub_add_url'),
                            sub_datas = $(sub_loader).find('input[name^="subaccounts"], select[name^="subaccounts"]').serializeObject(),
                            token = $('meta[name="csrf-token"]').attr('content'),
                            existing_sub_id = $(sub_loader).find('[name^="new_subaccount"]').val();

                        $.ajax({
                            url: sub_add_url,
                            data: {
                                _token: token,
                                data: sub_datas,
                                existing_sub_id: existing_sub_id,
                            },
                            //dataType: 'json',
                            type: 'PUT',
                            success: function (r) {
                                $(sub_loader).subaccount();
                            }
                        });
                    });

                // DELETE SUB
                $(sub_loader).find('.btn-rm-sub')
                    .off('click')
                    .on('click', function () {

                        var sub_rm_url = $(this).data('sub_rm_url'),
                            sub_i = $(this).data('sub_i'),
                            sub_datas = $(sub_loader).find('input[name^="subaccounts"], select[name^="subaccounts"]').serializeObject(),
                            token = $('meta[name="csrf-token"]').attr('content');

                        $.ajax({
                            url: sub_rm_url,
                            data: {
                                _token: token,
                                data: sub_datas,
                                remove_sub_i: sub_i,
                            },
                            type: 'DELETE',

                            success: function (r) {
                                $(sub_loader).subaccount();
                            }
                        });
                    });

                $(sub_loader).find('[name^="subaccount"]')
                    .off('change')
                    .on('change', function () {
                        var sub_datas = $(sub_loader).find('input[name^="subaccount"], select[name^="subaccount"]').serializeObject(),
                            token = $('meta[name="csrf-token"]').attr('content');

                        $.ajax({
                            url: sub_url,
                            data: {
                                _token: token,
                                data: sub_datas,
                            },
                            //dataType: 'json',
                            type: 'PATCH',
                            success: function (r) {
                                //$(sub_loader).subaccount();
                            }
                        });

                    });


                $('#payment-form').on('keyup keypress', function (e) {
                    var keyCode = e.keyCode || e.which;
                    if (keyCode === 13) {
                        e.preventDefault();
                        return false;
                    }
                });
            }
        });

    };

    // find and active all subaccounts loader ...
    $.fn.checkout_subAccounts = function (options) {

        if ($('.subaccounts-loader').length > 0) {
            $.each($('.subaccounts-loader'), function () {
                $(this).subaccount(options);
            });
        }

    };

    $.fn.promoCode = function () {

        var promo_url = $(this).data('promo_url'),
            code = $('[name="promo_code"]').val();

        if (code.length > 0) {
            $.ajax({
                url: promo_url,
                dataType: "json",
                type: "POST",
                data: {
                    _token: window.Laravel.csrfToken,
                    code: code,
                },
                success: function (r) {

                    console.log("promor", r);
                    
                    if (r.success == true) {

                        if ((has_gtag == true) && (typeof r.gtag !== "undefined")) {
                            window?.dataLayer?.push({ 'event': 'select_content', ecommerce: { 'promotions': [ r.gtag ] } });
                        }

                        document.location.reload();
                    } else {
                        $.fn.swal({
                            title: r.code,
                            text: r.msg,
                            type: 'warning',
                            showCancelButton: false,
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-danger btn-raised',
                            //cancelButtonClass : 'btn btn-default',
                            confirmButtonText: r.btnText,
                            allowOutsideClick: false,
                            timer: 6000,
                        });
                    }
                }
            })
        } else {
            //alert("Code cannot be null")
        }

    };

    $.fn.quickRegister = function (options) {

        var is_registred = (typeof options.is_registred !== "undefined") ? options.is_registred : 0;

        $(document)
            .on('click', '.new_subaccount', function () {
                var _subaccount_root = $('#subaccount_root').clone(),
                    _i = Math.random().toString(36).substr(2, 9);

                $.each(_subaccount_root.find('.form-control'), function () {
                    var _name = $(this).attr('name').replace('_ROOT_', _i);
                    $(this).attr('name', _name);
                });

                _subaccount_root.attr('id', '_subaccount_' + _i); //
                _subaccount_root.attr('data-sub_i', _i);
                _subaccount_root.find('button[data-remove_sub]').attr('data-remove_sub', _i);
                _subaccount_root.removeClass('hide');
                $('#subaccounts_receiver').append(_subaccount_root);

                $('.birthday').inputmask({alias: "date", inputFormat: "jj/mm/aaaa"});
            })
            .on('click', '[data-remove_sub]', function () {
                var _i = $(this).data('remove_sub');
                $('.subaccount_item[data-sub_i="' + _i + '"]').remove();
            })

        ;

        if (is_registred != 0) {

            $.fn.swal({
                title: options.swal_success.title,
                html: options.swal_success.message,
                type: 'success',
                showCancelButton: false,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-default',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                timer: 10000,
            });

        }


        if ($('#waiver').length > 0) {

            var waiver = $('#waiver');

            $('#qrSubmit').attr('disabled', true);
            waiver.jqSignature({
                width: "100%",
                height: 350,
                border: 0,
                background: '#F0F0F0',
                lineColor: "#000",
                lineWidth: 3,
                autoFit: true
            });


            $('#waiver')
                .on('jq.signature.changed', function () {
                    $('#qrSubmit').attr('disabled', false);
                    var getDataURL = waiver.jqSignature("getDataURL");
                    $('[name="waiver[data]"]').val(getDataURL);
                });

            $(document)
                .on('click', '[data-waiver="clear"]', function () {
                    waiver.jqSignature('clearCanvas');
                    $('[name="waiver[data]"]').val('');
                    $('#qrSubmit').attr('disabled', true);
                })
            ;

            function saveSignature() {
                $('#signature').empty();
                var dataUrl = $('.js-signature').eq(1).jqSignature('getDataURL');
                var img = $('<img>').attr('src', dataUrl);
                $('#signature').append($('<p>').text("Here's your signature:"));
                $('#signature').append(img);
            }


        }

    };

    $.fn.memberProfil = function (options) {


        $(document)
            .on('click', '[data-anonymousable]', function () {

                $.fn.swal({
                    title: options.anonymous.title,
                    text: options.anonymous.text,
                    type: 'warning',
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    confirmButtonText: options.anonymous.confirmButtonText,
                    confirmButtonClass: 'btn btn-danger btn-raised',
                    cancelButtonText: options.anonymous.cancelButtonText,
                    cancelButtonClass: 'btn btn-default btn-raised',
                    buttonsStyling: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: true,
                    input: 'text',
                    preConfirm: function (yes) {
                        return new Promise(function (resolve, reject) {
                            setTimeout(function () {
                                if (yes !== options.anonymous.key) {
                                    reject(options.anonymous.reject)
                                } else {
                                    resolve()
                                }
                            }, 2000);
                        })
                    },
                }).then(function () {

                    $.ajax({
                        url: options.anonymous.ajaxUrl,
                        type: "POST",
                        data: {
                            _token: window.Laravel.csrfToken,
                        },
                        success: function (response) {
                            if (response.success == true)
                                document.location.href = options.anonymous.logoutUrl;
                        }
                    });

                }, function (dismiss) {
                });


            })
        ;

        setTimeout(function () {
            $('[name="email"], [name="password"], [name="password_confirmation"]').prop('readonly', false);
        }, 300)

    };

    /* PACKAGE **/
    $.fn.packSteps = function (options, steps) {



        let currentStep = eval(steps.n),
            maxStep = eval(steps.choices),
            nextStep = currentStep + 1;

        if (nextStep <= maxStep) {
            let nextchoice = $($('[data-loaded_choice]')[nextStep]);
            // for multi day packs check if next step is not already loaded AND selected
            if(options.multi_day == undefined || !options.multi_day || nextchoice.find('[name="pack_choices[' + nextchoice.data('choice_id') + '][agenda_activity_id]"]').val() == undefined){
                nextchoice.packChoice(options, nextStep);
            }
        }

        // Submit -- disabled ?
         // if no step : you can't book a pack
         let missing_active_slot = false;
         if ($('div.btn-group.btn-group-slider').length <= 0) {
             missing_active_slot = true;
         }
         // if not at least one active slot/step : you can't book a pack
         $('div.pack-activity-choice').each(function (item) {
             let active_elements = $(this).find('a.active');
             if (active_elements.length == 0) {
                 missing_active_slot = true;
             }
         });
         // Submit -- disabled ?
         if (!missing_active_slot) {
             $('#pack-submitter').prop('disabled', false);
         } else {
             $('#pack-submitter').prop('disabled', true);
         }

    };

    $.fn.multiPackSteps = function (options, n) {
        // if no step : you can't book a pack
        let missing_active_slot = false;
        if ($('div.btn-group.btn-group-slider').length <= 0) {
            missing_active_slot = true;
        }
        // if not at least one active slot/step : you can't book a pack
        $('div.pack-activity-choice').each(function (item) {
            let active_elements = $(this).find('a.active');
            if (active_elements.length == 0) {
                missing_active_slot = true;
            }
        });
        // Submit -- disabled ?
        if (!missing_active_slot) {
            $('#pack-submitter').prop('disabled', false);
        } else {
            $('#pack-submitter').prop('disabled', true);
        }

    };

    $.fn.resetPackAfter = function (options, choice_id, n) {

        ///console.log("[ CALL ] 🔱 resetPackAfter  ->" + choice_id + " -> " + n);

        $('#pack-submitter').prop('disabled', true);
        $.each($('[data-choice_id]'), function (i, item) {
            if (i > n) {
                $(this).html('&nbsp;');
                // Reset label
                $('[data-pack_recap="' + $(this).data('choice_id') + '"]').find('span').html('&nbsp;');
            }
        });

    };

    $.fn.packSlotsSlider = function (options, choice_id, option_id, location_auto, steps) {
        //console.log("options_begin",options);
        qLog("[ CALL ] packSlotsSlider  ->" + choice_id, 'orange');

        let choice          = $(this),
            slide           = choice.find('.pack-slot-slide'),
            container       = slide.find('.pack-slot-slider-container'),
            slider          = container.find('.btn-group-slider'),
            btn_qty         = slider.find('.btn').length,
            sliding_left    = (slider.outerWidth() / btn_qty),
            slide_position  = 0,
            slide_visible   = Math.floor(container.outerWidth() / sliding_left),
            slide_qty       = slide_visible,
            left            = 0,
            toSlide         = (ResponsiveBootstrapToolkit.current() === "xs") ? 1 : 2;

            slide
                .off('click', '[data-pack_shift]')
                .on('click', '[data-pack_shift]', function () {

                    let direction = $(this).data('pack_shift');

                    slide_position = (direction == 'left') ? slide_position - toSlide : slide_position + toSlide;

                    // max at left
                    if (slide_position <= 0) slide_position = 0;

                    // max at right
                    if (slide_position >= (btn_qty - slide_visible)) slide_position = (btn_qty - slide_visible);

                    left = -(slide_position * sliding_left);

                    slider.animate({left: left}, 300, "easeOutQuint");

                })

            .off('click', '[data-pack_selected_slot]')
            .on('click', '[data-pack_selected_slot]', function () {

                let selected_slot = $(this).data('pack_selected_slot'),
                    pack_location_url = $(this).data('pack_location_url'),
                    qty = $('[name="qty"]').val(),
                    location_loader = $('[data-locations_loader="' + choice_id + '"]'),
                    start_at = $('[name="start_at"]').val(),
                    previous_option_id = 0;

                slider.find('[data-pack_selected_slot]').removeClass('active');
                $(this).addClass('active');
                //console.log("steps_on",steps);
                if(options.multi_day == undefined || options.multi_day != true){
                    $.fn.resetPackAfter(options, choice_id, steps.n);
                }

                // Set slot
                let pack_recap = $('[data-pack_recap="' + choice_id + '"]'),
                    slot_value = $(this).find('span.start_at').html(),
                    separator = pack_recap.data('separator');

                pack_recap.find('span.pack-check').html('<i class="mdi mdi-check text-success"></i>');

                if ((options.pack_is_constrained === "1") && (options.constrained_show_slot !== "0")) {
                    pack_recap.find('span.pack-slot').html(separator + " " + slot_value);
                } else {
                    pack_recap.find('span.pack-slot').hide();
                }

                // GET LOCATIONS
                $.ajax({
                    url: pack_location_url,
                    data: {
                        qty: qty,
                        start_at: start_at,
                        data: $("#pack-form").serializeObject(),
                        choice_id: choice_id,
                        option_id: option_id,
                        location_auto: location_auto,
                        n: steps.n,
                    },
                    beforeSend: function () {

                        location_loader.hide();
                        location_loader.html('&nbsp;');

                        $('#pack-submitter').prop('disabled', true);


                    },
                    success: function (response) {

                        location_loader.html(response);

                        // Selection auto du lieu
                        if (location_auto <= 0) {

                            setTimeout(function () {
                                location_loader.show();

                                let selector = location_loader.find('.pack-locations-selector');

                                /*$("html, body").animate({
                                    scrollTop: location_loader.offset().top
                                }, 500);*/

                                location_loader
                                    .off('click', '[data-select_agenda_activity]')
                                    .on('click', '[data-select_agenda_activity]', function () {

                                        $(this).parent('div').find('a.active').removeClass('active');
                                        $(this).addClass("active");

                                        $('[name="pack_choices[' + choice_id + '][agenda_activity_id]"]').val($(this).data('select_agenda_activity'));
                                        $.fn.packSteps(options, steps);

                                        // Locations label
                                        let active_location = selector.find('.pack-location.active');
                                        if (active_location.length > 0) {
                                            let location_label = active_location.find('.pack-location-text').text();
                                            pack_recap.find('span.pack-location').html(" - " + location_label);
                                        }

                                    });

                                // auto select uniq location
                                if (location_loader.find('[data-select_agenda_activity]').length == 1) {
                                    location_loader.find('[data-select_agenda_activity]:first()').trigger('click');
                                } else {
                                    // Si plusieurs choix de location possible on affiche le panel body
                                    if (location_loader.find('[data-select_agenda_activity]').length > 0) {
                                        choice.parent().show();
                                    }
                                }

                            }, 200);

                            // Choix du lieu
                        } else {
                            $.fn.packSteps(options, steps);
                        }

                    }
                });

            })
        ;

        slider.swipe({
            //Generic swipe handler for all directions
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {

                if (direction == "left")
                    slide.find('[data-pack_shift="right"]').trigger("click");


                if (direction == "right")
                    slide.find('[data-pack_shift="left"]').trigger("click");

            }
        });

    };

    $.fn.packAjax = function (options, n) {

        let loader = $(this),
            choice_url = options.choice_url,
            choice_id = loader.data('choice_id'),
            qty = $('[name="qty"]').val(),
            start_at = $('[name="start_at"]').val(),
            wait = options.wait,
            choices = $('[data-loaded_choice]').length,
            steps = {
                n: n,
                choices: choices
            },
            previous_choice_id = null,
            previous_option_id = null,
            option_id = null;

        qLog("[ CALL ] packAjax #"+n+" -> " + choice_url, 'orange');

        if (this.length == 0) {
            return false;
        }

        if (n > 0) {

            previous_choice_id = $('[data-i="' + (n - 1) + '"]').data('choice_id');

            if ($('[name="pack_choices[' + previous_choice_id + '][selected_product_id]"]').length == 1) {
                previous_option_id = $('[name="pack_choices[' + previous_choice_id + '][selected_product_id]"] > option:first').data('option_id');
            } else {
                previous_option_id = $('[name="pack_choices[' + previous_choice_id + '][selected_product_id]"]:selected').data('option_id');
            }

        }

        let data = $('#pack-form').serializeObject();

        $.ajax({
            url: choice_url,
            data: {
                qty: qty,
                start_at: start_at,
                data: data,
                choice_id: choice_id,
                option_id: option_id,
                previous_choice_id: previous_choice_id,
                previous_option_id: previous_option_id,
                n: n,
            },
            beforeSend: function () {

                //loader.hide();
                //loader.html('&nbsp;');

                $('#pack-submitter').prop('disabled', true);

                loader.find('.pack-waiter').show();

            },
            success: function (r) {

                loader.html(r);
                loader.show();
                loader.attr('data-loaded_choice', 1);

                $('[data-toggle="popover"]').popover({
                    html: true,
                    container: 'body',
                    placement: function (context, source) {
                        var position = $(source).position();

                        if (position.left > 515) {
                            return "left";
                        }

                        if (position.left < 515) {
                            return "right";
                        }

                        if (position.top < 110) {
                            return "bottom";
                        }

                        return "top";
                    }
                });

                loader
                    .off('change', '[data-option_activity]')
                    .on('change', '[data-option_activity]', function () {

                        
                        let slotsLoader = $('[data-slots_loader="' + choice_id + '"]'),
                            pack_slots_url = slotsLoader.data('pack_slots_url'),
                            product_id = $(this).val(),
                            option_id = $(this).find('[value="' + product_id + '"]:first').data('option_id'),
                            location_auto = $(this).find('[value="' + product_id + '"]:first').data('location_auto'),
                            activity_label = $(this).find('[value="' + product_id + '"]:first').text();
                           
                        //console.log($(this));
                        //console.log(n);
                        //console.log(slotsLoader);
                        
                        $.fn.resetPackAfter(options, choice_id, n);
                        
                        if (product_id) {

                            let slotData =  $("#pack-form").serializeObject();

                            $.ajax({
                                url: pack_slots_url,
                                type: "POST",
                                data: {
                                    _token: $('meta[name="csrf-token"]').attr('content'),
                                    qty: qty,
                                    start_at: start_at,
                                    choice_id: choice_id,
                                    option_id: option_id,
                                    product_id: product_id,
                                    previous_choice_id: (n > 0) ? 'ok' : null,
                                    previous_option_id: (n > 0) ? 'ok' : null,
                                    previous_agenda_activity_id: null,
                                    data: slotData,
                                    n: n,
                                },

                                beforeSend: function () {

                                    //slotsLoader.hide();
                                    //slotsLoader.html('&nbsp;');
                                    //loader.find('.panel-body').hide();

                                    slotsLoader.css('opacity', '.5')
                                    $('[data-pack_recap="' + choice_id + '"]').find('span').html('&nbsp;');
                                    $('[data-locations_loader="' + choice_id + '"]').html('&nbsp;');

                                },
                                success: function (response) {

                                    slotsLoader.html(response);

                                    let foundedSlots = slotsLoader.find('[data-pack_selected_slot]').length;
                                    //console.log("foundedSlots", foundedSlots)

                                    if (foundedSlots <= 0) {
                                        loader.find('.pack-activity').hide();
                                        loader.find('.pack-slot').html('<strong class="text-danger"><i class="mdi mdi-badminton"></i> ' + options.noSlotsFoundText + '</strong>');
                                        return;
                                    }


                                    // mode constrain if only one slot
                                    if ((foundedSlots == 1)
                                        && (n !== 0)
                                        && (options.pack_is_constrained === "1")
                                    ) {
                                        loader.find('.panel-body').hide();
                                        slotsLoader.packSlotsSlider(options, choice_id, option_id, location_auto, steps);
                                        slotsLoader.find('[data-pack_selected_slot]').first().trigger('click');

                                    } else {
                                        loader.find('.panel-body').show();
                                        slotsLoader.show();
                                        slotsLoader.packSlotsSlider(options, choice_id, option_id, location_auto, steps);
                                    }


                                    slotsLoader.css('opacity', '1')

                                }
                            });

                            // filling choice
                            $('[data-pack_recap="' + choice_id + '"]').find('span.pack-activity').html(activity_label);
                        } else {

                            slotsLoader.hide();
                            slotsLoader.html('&nbsp;');
                            $('[data-locations_loader="' + choice_id + '"]').html('&nbsp;');
                            $('[data-pack_recap="' + choice_id + '"]').find('span').html('&nbsp;');

                        }
                    })
                ;

                // only one activity choice
                if (loader.find('[data-option_activity] > option ').length === 1) {
                    loader.find('[data-option_activity]').trigger('change');

                    if (n > 0) {
                        if (options.constrained_show_slot != 1) {
                            //loader.hide();
                        } else {

                        }
                    } else {
                    }
                } else {

                    //console.log("--- 444");
                }

                loader.find('.pack-waiter').hide();

                // Scroll to next choice
                if (($('.pack-activity-choice').length > 1) && (n > 0)) {
                    $("html, body").animate({
                        scrollTop: loader.offset().top
                    }, 600);

                    //console.info("scroll to ", loader);
                }
            }
        });

    }

    $.fn.packChoice = function (options, n) {

        let loader = $(this),
            timer = null,
            choice_url = options.choice_url,
            choice_id = loader.data('choice_id'),
            qty = $('[name="qty"]').val(),
            start_at = $('[name="start_at"]').val(),
            wait = options.wait,
            choices = $('[data-loaded_choice]').length,
            i = $(this).data('i'),
            pack_is_multi_day = ($('[name="pack_is_multi_day"]').val() === "1") ? true : false,
            steps = {
                n: n,
                choices: choices
            };

        if (this.length == 0)
            return false;

        qLog("[ CALL ] 🍑 packChoice n "+ n, 'aqua');

        //console.log(" pack_is_multi_day ? ", pack_is_multi_day);
        options.multi_day = pack_is_multi_day;
        loader.packAjax(options, n);

        if (n === 0) {
            $(document)
                //.off('change textInput input', '[name="qty"]')
                .on('change textInput input', '[name="qty"]', function () {
                    clearTimeout(timer);
                    $('#pack-submitter').prop('disabled', true);
                    timer = setTimeout(function () {
                        $.fn.resetPackAfter(options, choice_id, 0);
                        $('[data-choice_id]:first').packAjax(options, 0);
                        //$('[data-choice_id]:first').packChoice(options, 0);
                    }, 600);
                })
                .off('change', '[name="start_at"]')
                .on('change', '[name="start_at"]', function () {
                    $('#pack-submitter').prop('disabled', true);
                    $.fn.resetPackAfter(options, choice_id, 0);
                    $('[data-choice_id]:first').packAjax(options, 0);
                });
        }

        $(document)
            .off('click', '[data-previous_at]')
            .on('click', '[data-previous_at]', function () {

                let clickedChoiceId     = $(this).data('pack_choice_id');
                let clickedChoiceRank   = $('[data-choice_id="' + clickedChoiceId + '"]').data('i');
                //console.log("clickedChoiceRank",clickedChoiceRank);
                // let previousChoiceRank = ((clickedChoiceRank - 1) > 0) ? (clickedChoiceRank - 1) : 0;  
                // let previousChoiceId = $('[data-i="' + previousChoiceRank + '"]').data('choice_id');
                let previousAtString    = (clickedChoiceRank == 0) ? start_at : $('[name="pack_choices[' + clickedChoiceId + '][previous_at]"]').val();
                let previousAt          = moment(previousAtString, "DD/MM/YYYY");
                let _packChoiceId       = $(this).data('pack_choice_id');

                let new_steps           = {n: clickedChoiceRank, choices: choices};
                //console.log("new_steps",new_steps);
                if ($(this).data('previous_at') === '+1') {
                    previousAt.add(1, 'days')
                } else {
                    previousAt.subtract(1, 'days')
                }

                $('[name="pack_choices[' + _packChoiceId + '][previous_at]"][data-pack_choice_id="' + _packChoiceId + '"]').val(previousAt.format("DD/MM/YYYY"))
                $('[data-is_previous_at_of="' + _packChoiceId + '"]').text(previousAt.format('DD/MM/YYYY'))



                // should only refetch the clicked step's slots
                let choice_loader   = $('div.pack-activity-choice[data-choice_id="' + _packChoiceId + '"]'),
                    choice_id       = choice_loader.data('choice_id'),
                    slots_loader    = $('div[data-slots_loader="' + choice_id + '"]'),
                    slots_url       = slots_loader.data('pack_slots_url'),
                    n               = choice_loader.data('i'),
                    optionsSelect   = choice_loader.find('[data-option_activity]'),
                    selectedOption  = (optionsSelect.children("option:selected").data("option_id") != undefined)?optionsSelect.children("option:selected").data("option_id"):optionsSelect.children("option:first").data("option_id") ;
                let slotData        = $("#pack-form").serializeObject();

                $.ajax({
                    url: slots_url,
                    method: "POST",
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        qty: qty,
                        start_at: previousAt.format('DD/MM/YYYY'),
                        product_id: optionsSelect.val(),
                        choice_id: clickedChoiceId,
                        option_id: selectedOption,
                        n: n,
                        is_multi_day: true,
                        data: slotData
                    },
                    beforeSend: function () {
                        slots_loader.css('opacity', '.5')
                        $('[data-locations_loader="' + choice_id + '"]').html('&nbsp;');
                    },
                    success: function (response) {

                        slots_loader.html(response);
                        $.fn.packSteps(options, n);

                        let foundedSlots = slots_loader.find('[data-pack_selected_slot]').length;
                        console.log("Whouuu! foundedSlots", foundedSlots);

                        if (foundedSlots <= 0) {
                            loader.find('.pack-activity').hide();
                            //loader.find('.pack-selected-slot').hide();
                            loader.find('.pack-slot').html('<strong class="text-danger"><i class="mdi mdi-badminton"></i> ' + options.noSlotsFoundText + '</strong>');
                            loader.find('.pack-slot').show();
                            
                            console.log("----rien?", {
                                activity: loader.find('.pack-activity'),
                                selectedSlot: loader.find('.pack-selected-slot'),
                                slot: loader.find('.pack-slot'),
                            });

                            return;
                        }else{
                            loader.find('.pack-slot').html('');
                            loader.find('.pack-activity').show();   
                            loader.find('.pack-selected-slot').show();
                        }

                        let location_auto = slots_loader.find('[data-pack_selected_slot]').first().data('location_auto');
                        
                        // mode constrain if only one slot
                        if ((foundedSlots == 1)
                            && (n !== 0)
                            && (options.pack_is_constrained === "1")) {
                            //console.log("mode contrained");
                            loader.find('.panel-body').hide();
                            //console.log("steps_before",new_steps);
                            slots_loader.packSlotsSlider(options, clickedChoiceId, selectedOption, location_auto, new_steps);
                            slots_loader.find('[data-pack_selected_slot]').first().trigger('click');

                        } else {
                            //console.log("mode free_pick");

                            loader.find('.panel-body').show();
                            slots_loader.show();
                            //console.log("selected_option",selectedOption);
                            slots_loader.packSlotsSlider(options, clickedChoiceId, selectedOption, location_auto, new_steps);
                        }
                        slots_loader.css('opacity', '1')
                    }
                });
            })
        ;

    };

    function formatDate(date) {
        return [
            padTo2Digits(date.getDate()),
            padTo2Digits(date.getMonth() + 1),
            date.getFullYear(),
        ].join('/');
    }

    $.fn.redirectAfterShopping = function () {
        if ($(this).length > 0) {

            let redirect = parseInt($(this).data('redirect')),
                redirectTo = $(this).data('redirect-url'),
                timeout = $(this).find('.timeout'),
                timer = null,
                cnt = redirect;

            timer = setInterval(function () {

                if (cnt === 0) {
                    document.location.href = redirectTo;
                }

                timeout.text(cnt);
                cnt--;

                console.info("Redirecting in " + cnt);

            }, 1000);

        }
    };

    $.fn.generalAttentionMessage = function () {

        var general_attention_message_acknowledge_url = $('meta[name="front_general_attention_message_acknowledge_url"]').attr('content'),
            general_attention_message_acknowledged = $('meta[name="front_general_attention_message_acknowledged"]').attr('content'),
            general_attention_message_enabled = $('meta[name="front_general_attention_message_enabled"]').attr('content'),
            general_attention_message_title = $('meta[name="front_general_attention_message_title"]').attr('content'),
            general_attention_message_content = $('meta[name="front_general_attention_message_content"]').attr('content'),
            general_attention_message_button = $('meta[name="front_general_attention_message_button"]').attr('content');


        if (general_attention_message_enabled === "1" && general_attention_message_acknowledged === "false") {
            $.fn.swal({
                title: general_attention_message_title,
                text: general_attention_message_content,
                type: 'info',
                showCancelButton: false,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                confirmButtonText: general_attention_message_button,
                allowOutsideClick: false
            }).then(function () {
                $.ajax({
                    url: general_attention_message_acknowledge_url,
                    type: "POST",
                    data: {
                        _token: window.Laravel.csrfToken,
                    },
                    success: function (response) {
                        console.log();
                    }
                });
            });
        }
    };

    $.fn.giftCards = function (options) {

        //console.log("Member GiftCards");

        $(document)
            .off('click', '[data-giftcard_detail_url]')
            .on('click', '[data-giftcard_detail_url]', function () {

                let giftcard_detail_url = $(this).data('giftcard_detail_url');

                function validateEmail(email) {
                    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                }

                $.ajax({
                    url: giftcard_detail_url,
                    success: function (r) {
                        $('#giftCardModal').html(r);
                        $('#giftCardModal').modal({show: true});

                        $(document)
                            .off('click', '[data-send_giftcard_url]')
                            .on('click', '[data-send_giftcard_url]', function () {

                                let send_giftcard_url = $(this).data('send_giftcard_url'),
                                    btn = $(this),
                                    gfId = $(this).data('gf_id'),
                                    giftcard_email = $('[name="giftcard_email"]').val();

                                //console.log("gfId", gfId);

                                $.ajax({
                                    url: send_giftcard_url,
                                    type: "POST",
                                    data: {
                                        giftcard_email: giftcard_email,
                                        _token: window.Laravel.csrfToken,
                                    },
                                    beforeSend: function () {

                                        btn.prop('disabled', true);

                                        btn.find('i').removeClass('mdi-email-send');
                                        btn.find('i').addClass('mdi-spin mdi-loading');

                                    },
                                    success: function (r) {
                                        // console.log("-r", r);

                                        btn.prop('disabled', false);
                                        btn.find('i').addClass('mdi-email-send');
                                        btn.find('i').removeClass('mdi-spin mdi-loading');

                                        if (r.success === true) {
                                            $('[data-was_send="' + gfId + '"]').html(r.was_sent_at);
                                            $('[data-giftcard_detail_url="' + giftcard_detail_url + '"]').trigger('click');
                                        }

                                    }
                                });

                            })

                            .off('input', '[name="giftcard_email"]')
                            .on('input', '[name="giftcard_email"]', function () {

                                if ($(this).val().length > 0 && (validateEmail($(this).val()))) {
                                    $('[data-send_giftcard_url]').prop('disabled', false);
                                } else {
                                    $('[data-send_giftcard_url]').prop('disabled', true);
                                }

                            })

                        ;

                    }
                });

            })

    };

    $.fn.CSE_distribution = function (options) {
        
        var selected_tickets_count = 0;
        var enabledSubmitOrMarkCSE = () => {
            var cse_email_to = $('input[name="cse_email_to"]').val();

            // Check email validity
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if (!emailReg.test(cse_email_to)) {
                $('#send-cse-email').attr('disabled', 'true');
                $('#mark-cse-distributed').attr('disabled', 'true');
                return;
            }

            if (cse_email_to && selected_tickets_count > 0) {
                $('#send-cse-email').removeAttr('disabled');
            } else {
                $('#send-cse-email').attr('disabled', 'true');
            }

            if( selected_tickets_count > 0 ){
                $('#mark-cse-distributed').removeAttr('disabled');
            }
            else{
                $('#mark-cse-distributed').attr('disabled', 'true');
            }
        };

        // enable send cse email button when cse email is entered and tickets are selected
        $('input[name="cse_email_to"]').on('input', function() {
            var cse_email_to = $(this).val();
            enabledSubmitOrMarkCSE();
        });

        // send cse email
        $('#send-cse-email').click(function() {
            var ticket_ids = [];
            $('input[name="ticket_id[]"]:checked').each(function() {
                ticket_ids.push($(this).val());
            });
            var cse_email_to = $('input[name="cse_email_to"]').val();
            if (ticket_ids.length > 0 && cse_email_to) {
                $.ajax({
                    url: options.cse_distribution_url,
                    type: 'POST',
                    data: {
                        _token: window.Laravel.csrfToken,
                        ticket_ids: ticket_ids,
                        cse_email_to: cse_email_to,
                    },
                    success: function(data) {
                        if (data.success) {
                            
                            $.fn.swal({
                                title: options.cse_email_send_title,
                                text: data.message,
                                type: 'success',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false,

                                onClose: function() {
                                    window.location.reload();
                                }
                            });

                        } else {
                            
                            $.fn.swal({
                                title: options.cse_email_send_title,
                                text: data.message,
                                type: 'warning',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false
                            });
                        }
                    }
                });
            } else {
                alert(options.cse_distribution_error_message);
            }
        });

        // update selected tickets count
        $('input[name="ticket_id[]"]').change(function() {

            selected_tickets_count = $('input[name="ticket_id[]"]:checked').length;

            $('.cse_selected_tickets_count').text(selected_tickets_count);
            
            // show selected tickets count if more than 0
            if (selected_tickets_count > 0) {
                $('.cse_selection_tips').hide();
                $('.cse_selected_tickets').show();
            } else {
                $('.cse_selection_tips').show();
                $('.cse_selected_tickets').hide();
            }

            enabledSubmitOrMarkCSE();
        }); 
        
        $('#mark-cse-distributed').click(function() {
            
            var ticket_ids = [];
            $('input[name="ticket_id[]"]:checked').each(function() {
                ticket_ids.push($(this).val());
            });
            
            if (ticket_ids.length > 0) {
                $.ajax({
                    url: options.cse_mark_as_distributed_url,
                    type: 'POST',
                    data: {
                        _token: window.Laravel.csrfToken,
                        ticket_ids: ticket_ids,
                    },
                    success: function(data) {
                        if (data.success) {
                            
                            $.fn.swal({
                                title: options.cse_mark_as_ditributed_title,
                                text: data.message,
                                type: 'success',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false,

                                onClose: function() {
                                    window.location.reload();
                                }
                            });

                        } else {
                            
                            $.fn.swal({
                                title: options.cse_mark_as_ditributed_title,
                                text: data.message,
                                type: 'warning',
                                showCancelButton: false,
                                //confirmButtonColor: '#f44336',
                                //cancelButtonColor: '#d33',

                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger',
                                cancelButtonClass: 'btn btn-default',

                                confirmButtonText: 'OK',
                                allowOutsideClick: false
                            });
                        }
                    }
                });
            } else {
                alert(options.cse_mark_as_ditributed_error_message);
            }
        });


    };

    $(document)
        .on('click', '.scrollTo', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);

        })
        .on('click', '[data-show_more]', function () {
            $('.long-description').toggle();
        })
        .on('click', '[data-promo_url]', function () {
            $(this).promoCode();
        })

    //
        .on("click", "#create-account-form-button", () => {

            let loginForm = $("#login-form"),
                createAccountForm = $('#create-account-form');

            if( !createAccountForm.hasClass('hidden') ){
                createAccountForm.addClass("hidden");
                return true
            }

            if( !loginForm.hasClass('hidden') ){
                loginForm.addClass('hidden');
            }

            createAccountForm.removeClass('hidden');

        })
        .on("click", "#connect-form-button", () => {

            let loginForm = $("#login-form"),
                createAccountForm = $('#create-account-form');

            if( !loginForm.hasClass('hidden') ){
                loginForm.addClass('hidden');
                return true;
            }

            if( !createAccountForm.hasClass("hidden") ){
                createAccountForm.addClass('hidden');
            }

            loginForm.removeClass("hidden");

        })
        .ready(function() {
            const method = $("#fromKiosk-panel-body").data('method'),
                loginForm = $("#login-form"),
                createAccountForm = $('#create-account-form');

            if (method !== "") {
                if (method === "login" && loginForm.hasClass('hidden')) {
                    loginForm.removeClass('hidden')
                } else if (method === "create" && createAccountForm.hasClass('hidden')) {
                    createAccountForm.removeClass('hidden');
                }
            }
        })
    ;

    /*document.getElementById('create-account-form-button')?.addEventListener('click', () => {
        const loginForm = document.getElementById('login-form');
        const createAccountForm = document.getElementById('create-account-form');

        if (!createAccountForm?.classList.contains('hidden'))
            return createAccountForm?.classList.add('hidden')
        if (!loginForm.classList?.contains('hidden'))
            loginForm?.classList.add('hidden');
        createAccountForm?.classList.remove('hidden');
    })

    document.getElementById('connect-form-button')?.addEventListener('click', () => {
        const loginForm = document.getElementById('login-form');
        const createAccountForm = document.getElementById('create-account-form');

        if (!loginForm?.classList.contains('hidden'))
            return loginForm?.classList.add('hidden')
        if (!createAccountForm?.classList.contains('hidden'))
            createAccountForm?.classList.add('hidden');
        loginForm?.classList?.remove('hidden');
    })*/

    $('#app-loading').fadeOut('fast', function () {

        /*if( setHeight == true )
            $('#app').iframeHeight('default');*/

    });

    $(this).generalAttentionMessage();

})(jQuery, ResponsiveBootstrapToolkit);

